import { makeStyles } from '@material-ui/core';
import { SvgIcon } from '@material-ui/core';

import { ReactComponent as Employees } from './employees_icon.svg';

const useStyles = makeStyles({
  icon: {
    width: '20px',
    height: '20px',
  },
});

export default function EmployeesIcon() {
  const classes = useStyles();

  return (
    <SvgIcon className={classes.icon} viewBox="0 0 24 24">
      <Employees />
    </SvgIcon>
  );
}
